// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1733":"89d15ba0","2193":"89d15ba0"}[chunkId] + ".chunk.css";
};